module.exports = __webpack_public_path__ + "img/MG.ded61a6f.svg";